import PropTypes from 'prop-types'

export const LegalFooter = ({
  variant = 'inline',
  prefix = 'By continuing, you agree to our',
  separator = 'and',
  privacyText = 'Privacy Policy',
  termsText = 'Terms of Service',
  showPrivacy = true,
  showTerms = true,
  textSize = 'xs',
  textColor = 'text-gray-500',
  linkColor = 'text-gray-400',
  linkHover = 'text-gray-300',
  target = '_blank',
  className = '',
}) => {
  const getTextSizeClass = () => {
    switch (textSize) {
      case 'xs':
        return 'text-xs'
      case 'sm':
        return 'text-sm'
      case 'base':
        return 'text-base'
      default:
        return 'text-xs'
    }
  }

  const getLayoutClass = () => {
    switch (variant) {
      case 'inline':
        return 'text-center'
      case 'block':
        return 'text-left'
      case 'stacked':
        return 'text-center flex flex-col gap-1'
      default:
        return 'text-center'
    }
  }

  const linkClasses = `${linkColor} hover:${linkHover} underline transition-colors`

  const renderLinks = () => {
    if (variant === 'stacked') {
      return (
        <>
          {showPrivacy && (
            <a
              href="/privacy-policy"
              target={target}
              rel={target === '_blank' ? 'noopener noreferrer' : undefined}
              className={linkClasses}
            >
              {privacyText}
            </a>
          )}
          {showPrivacy && showTerms && <span className={textColor}>{separator}</span>}
          {showTerms && (
            <a
              href="/terms-of-service"
              target={target}
              rel={target === '_blank' ? 'noopener noreferrer' : undefined}
              className={linkClasses}
            >
              {termsText}
            </a>
          )}
        </>
      )
    }

    return (
      <>
        {showPrivacy && (
          <a
            href="/privacy-policy"
            target={target}
            rel={target === '_blank' ? 'noopener noreferrer' : undefined}
            className={linkClasses}
          >
            {privacyText}
          </a>
        )}
        {showPrivacy && showTerms && ` ${separator} `}
        {showTerms && (
          <a
            href="/terms-of-service"
            target={target}
            rel={target === '_blank' ? 'noopener noreferrer' : undefined}
            className={linkClasses}
          >
            {termsText}
          </a>
        )}
      </>
    )
  }

  return (
    <div className={`${getLayoutClass()} ${getTextSizeClass()} ${textColor} ${className}`}>
      {prefix && `${prefix} `}
      {renderLinks()}
    </div>
  )
}

LegalFooter.propTypes = {
  variant: PropTypes.oneOf(['inline', 'block', 'stacked']),
  prefix: PropTypes.string,
  separator: PropTypes.string,
  privacyText: PropTypes.string,
  termsText: PropTypes.string,
  showPrivacy: PropTypes.bool,
  showTerms: PropTypes.bool,
  textSize: PropTypes.oneOf(['xs', 'sm', 'base']),
  textColor: PropTypes.string,
  linkColor: PropTypes.string,
  linkHover: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
}

export default LegalFooter
